export default "__VITE_ASSET__5a9dffad__"